module.exports = __webpack_public_path__ + "img/4.fc62f443.jpg";